export const initialInteractionState: InteractiveState = {
  selectedNodeIds: [],
  draggedNodeIds: [],
  hoveredNodeId: null,
  hoveredDropZones: {},
  targetedDropZone: null,
  dropZones: {},
};

export enum InteractionType {
  DragStart = 'DragStart',
  DragEnd = 'DragEnd',
  DragEnter = 'DragEnter',
  DragLeave = 'DragLeave',
  Selected = 'Selected',
}

interface InteractiveState {
  selectedNodeIds: string[];
  hoveredNodeId: string | null;
  draggedNodeIds: string[];
  targetedDropZone: string | null;
  hoveredDropZones: Record<string, { showDropIn?: boolean; showDropAfter?: boolean } | undefined>;
  dropZones: Record<string, { canDropIn: true | string; canDropAfter: true | string } | undefined>;
}

export type SetDragEnter = {
  type: InteractionType.DragEnter;
  payload: {
    hoveredDropZones: Record<string, { showDropIn?: boolean; showDropAfter?: boolean }>;
    targetedDropZone: string;
  };
};

export type SetDragLeave = {
  type: InteractionType.DragLeave;
};

export type SetSelected = {
  type: InteractionType.Selected;
  payload: {
    selectedNodeIds: string[];
  };
};

export type SetDragStart = {
  type: InteractionType.DragStart;
  payload: {
    draggedNodeIds: string[];
    dropZones: Record<string, { canDropIn: true | string; canDropAfter: true | string }>;
  };
};

export type SetDragEnd = {
  type: InteractionType.DragEnd;
};

type InteractiveAction = SetDragEnter | SetDragLeave | SetDragStart | SetDragEnd | SetSelected;

export const reducer = (state: InteractiveState, action: InteractiveAction): InteractiveState => {
  switch (action.type) {
    case InteractionType.Selected: {
      return { ...state, ...action.payload };
    }
    case InteractionType.DragEnter: {
      return { ...state, ...action.payload };
    }
    case InteractionType.DragStart: {
      return { ...state, selectedNodeIds: [], ...action.payload };
    }
    case InteractionType.DragLeave: {
      return {
        ...state,
        hoveredDropZones: {},
        targetedDropZone: null,
      };
    }
    case InteractionType.DragEnd: {
      return {
        ...state,
        selectedNodeIds: state.draggedNodeIds,
        draggedNodeIds: [],
        hoveredNodeId: null,
        hoveredDropZones: {},
        targetedDropZone: null,
        dropZones: {},
      };
    }
    default:
      return state;
  }
};
